// extracted by mini-css-extract-plugin
module.exports = {"card":"Subscription_card__33qYO","container":"Subscription_container__3Vnc6","padder":"Subscription_padder__1vllA","spinner":"Subscription_spinner__FIY-4"};